module.exports = __webpack_public_path__ + "static/media/liomlogo.4b747b2d.jpg";